'use client';

import { createContext, useContext, FC, PropsWithChildren } from 'react';
import { PhaserProps } from './types';

const PhaserContext = createContext<PhaserProps | undefined>(undefined);

export const PhaserProvider: FC<
  PropsWithChildren<{ phaser?: PhaserProps }>
> = ({ children, phaser }) => {
  return (
    <PhaserContext.Provider value={phaser}>{children}</PhaserContext.Provider>
  );
};

export const usePhaser = () => {
  return useContext(PhaserContext);
};
